// extracted by mini-css-extract-plugin
module.exports = {"mobile_image":"MobileCarousel_mobile_image__EU2r3","bg_transparent":"MobileCarousel_bg_transparent__lhlcR"};